import { render } from "./download-report.vue?vue&type=template&id=66471aba&scoped=true"
import script from "./download-report.vue?vue&type=script&lang=js"
export * from "./download-report.vue?vue&type=script&lang=js"

import "./download-report.vue?vue&type=style&index=0&id=66471aba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66471aba"]])

export default __exports__